"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const isClient_1 = require("../utils/isClient");
/**
 * Get the window size.
 */
exports.useWindowSize = () => {
    if (!isClient_1.isClient()) {
        return { width: -1, height: -1 };
    }
    const [windowSize, setWindowSize] = react_1.useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    react_1.useEffect(() => {
        const handler = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
        window.addEventListener("resize", handler);
        return () => window.removeEventListener("resize", handler);
    }, []);
    return windowSize;
};
exports.default = exports.useWindowSize;
//# sourceMappingURL=index.js.map